import type {ReactElement} from 'react';
import React from 'react';
import styles from './pulsating-dot.module.scss';

interface PulsatingDotProps {
  containerClassname: string;
  pulseColor?: string;
  dotColor?: string;
  showPulse?: boolean;
}

export function PulsatingDot({showPulse = true, ...props}: PulsatingDotProps): ReactElement<any> {
  return (
    <div className={props.containerClassname}>
      <div className={`radius-round ${props.dotColor ?? 'bg-secondary-150'} ${styles.dot}`} />
      {showPulse ? <div className={`radius-round ${props.pulseColor ?? 'bg-secondary-50'} ${styles.pulse}`} /> : null}
    </div>
  );
}
